export default (count, size) => {
  return Math.ceil(count / size) - 1
}
